const { default: axios } = require("axios");

const FormAjax = function () {

    const formAjax = function (e) {

        //const values = form.serialize();
        const form = $(this);
        var values = new FormData(this);
        const button = form.find('button');

        //Recaptcha Google V2 box
        var reCaptchaValided    = true;
        var hasRecaptcha        = false;

        form.find('.custom-captcha-error').hide();
        if( form.find("[name=g-recaptcha-response]").length > 0 ) {
            hasRecaptcha = true;
            if ( form.find("[name=g-recaptcha-response]").val() === '' ) {
                e.preventDefault();
                form.find('.custom-captcha-error').show();
                reCaptchaValided = false;
            }
        }

        if(!reCaptchaValided){
            return false;
        }

        button.attr('disabled', 'disabled');
        button.text('Enviando');
        
        Swal.fire({
            title: 'Por favor, Aguarde...',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;

                Swal.close();

                Swal.fire({
                    icon: data.error == false ? 'success' : 'error',
                    title: data.message,
                    showConfirmButton: false,
                    timer: 3000
                })

                // close modal agendar visita
                if($('#modal-visita').length > 0){
                    $('#modal-visita').modal('hide');
                }
 
                if(hasRecaptcha){
                    var c = $('.g-recaptcha').length;
                    for (var i = 0; i < c; i++)
                        grecaptcha.reset(i);
                }

                button.removeAttr('disabled');
                button.text('Enviar');    
                
                form.trigger("reset");    

            });

        e.preventDefault();
    }

    const autoCep = function(){

        const inputCep = $(this);
        const thisForm = inputCep.closest('form');
        if (inputCep) {
            const cep = inputCep.val();
            if (cep.length >= 9) {
                const URL = "https://viacep.com.br/ws/"+cep.replace('-', '')+"/json/";
                axios.get(URL)
                    .then(resposta => camposCep(resposta.data, thisForm))
                    .catch(erro => console.error(erro));
            }
        }

    }

    const camposCep = function(data, form){

        $(form).find('.cep-bairro').val(data.bairro)
        $(form).find('.cep-complemento').val(data.complemento)
        $(form).find('.cep-endereco').val(data.logradouro)
        $(form).find('.cep-cidade').val(data.localidade)
        //$('.cep-uf').val(data.uf);

        $(form).find(".cep-uf option").filter(function() {
            return this.text == data.uf; 
        }).attr('selected', true);

        //select customizado
        $(form).find('.cep-custom-select .select-selected').text(data.uf);

    }

    const CaptchaCallback = function() {
        $('.g-recaptcha').each(function(index, el) {
            grecaptcha.render(el, {
                'sitekey'           : $(el).attr('data-sitekey')
                ,'theme'            : $(el).attr('data-theme')
                ,'size'             : $(el).attr('data-size')
                ,'tabindex'         : $(el).attr('data-tabindex')
                ,'callback'         : $(el).attr('data-callback')
                ,'expired-callback' : $(el).attr('data-expired-callback')
                ,'error-callback'   : $(el).attr('data-error-callback')
            });

        });
    };

    return {
        init: function () {
            $(document).on('submit', '.form-ajax', formAjax);

            $('.cep').on('keyup', autoCep);

            CaptchaCallback();

        }
    }
}();

module.exports = FormAjax;